<template>
  <div>
    <div id="options-container" class="mt-2">
      <!-- <div
        :class="getSelectionStyle(PaymentMethod.codi)"
        @click="selectStore(PaymentMethod.codi)"
      >
        <img :src="`${useAsset('img/credit-line/codi.png')}`" alt="CoDi" />
        <span class="ms-3">CoDi</span>
      </div> -->
      <div
        :class="getSelectionStyle(PaymentMethod.spei)"
        @click="selectStore(PaymentMethod.spei)"
      >
        <img :src="`${useAsset('img/credit-line/bank.png')}`" alt="SPEI" />
        <span class="ms-3">{{ t("SPEI") }}</span>
      </div>
      <div
        :class="getSelectionStyle(PaymentMethod.oxxo)"
        @click="selectStore(PaymentMethod.oxxo)"
      >
        <img :src="`${useAsset('img/credit-line/oxxo.png')}`" alt="OXXO" />
        <span class="ms-3">{{ t("OXXO") }}</span>
      </div>
      <div
        :class="getSelectionStyle(PaymentMethod.store)"
        @click="selectStore(PaymentMethod.store)"
      >
        <img :src="`${useAsset('img/credit-line/store.png')}`" alt="Store" />
        <span class="ms-3">{{ t("CONVENIENCESTORE") }}</span>
      </div>
      <div class="text-center bottom-btn" v-if="isStoreCodiOrDealer">
        <button
          class="select-method-btn"
          :class="fetchingPayment ? 'disabled-button' : ''"
          @click="checkSelectedStore()"
          :disabled="fetchingPayment"
        >
          {{ t("SELECT") }}
        </button>
      </div>
    </div>
    <div id="phone-step-section" v-if="selectedStore === PaymentMethod.codi">
      <p class="fw-bold color-black">{{ t("ONEMORESTEP") }}:</p>
      <p class="fw-bold">{{ t("ONEMORESTEPDESCRIPTION") }}</p>
      <div v-if="userNumber !== null">
        <input
          type="radio"
          value="thisnumber"
          id="thisnumber"
          v-model="pickedPhone"
        />
        <label for="thisnumber" class="ms-2">{{ userNumber }}</label>
      </div>
      <div class="d-flex align-items-start mt-2">
        <input
          type="radio"
          value="othernumber"
          id="othernumber"
          v-model="pickedPhone"
        />
        <div class="ms-2 d-grid w-90">
          <label for="othernumber">{{ t("NEWNUMBER") }}</label>
          <input type="text" class="number-input" v-model="otherNumber" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { PaymentMethod } from "@/apps/credit-line/types/payment";
import useAsset from "@/apps/credit-line/helpers/useAsset";

const { t } = useI18n();
const getSelectionStyle = inject("getSelectionStyle");
const selectStore = inject("selectStore");
const isStoreCodiOrDealer = inject("isStoreCodiOrDealer");
const fetchingPayment = inject("fetchingPayment");
const checkSelectedStore = inject("checkSelectedStore");
const userNumber = inject("userNumber");
const pickedPhone = inject("pickedPhone");
const otherNumber = inject("otherNumber");
const selectedStore = inject("selectedStore");
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

.green-option {
  background-color: $pj-color-green-hover;
  font-weight: bold;
  padding: 5%;
}

.regular-option {
  font-weight: bold;
  padding: 5%;
}

.select-method-btn {
  border: none;
  background-color: $pj-color-green;
  color: $pj-color-white;
  width: 85%;
  border-radius: 10px;
  font-weight: bold;
  height: 50px;
}

.bottom-btn {
  width: 100%;
  margin: 0 auto;
  position: fixed;
  left: 0;
  bottom: 25px;
}

#phone-step-section {
  padding: 5%;
}

.color-black {
  color: $pj-color-black;
}

.disabled-button {
  opacity: 0.5;
}

.w-90 {
  width: 90%;
}

.number-input {
  background: $pj-color-white;

  /* coolGray/200 */
  border: 1px solid $pj-color-lighter-gray;

  /* shadow-base */
  box-shadow: 0 1px 2px rgba(31, 41, 55, 0.08);
  border-radius: 4px;
}
</style>
